export enum ProductTestIds {
  PRODUCT_GRID = 'all-products-page__product-grid',
  PRODUCT_CARD = 'product-card__card',
  PRODUCT_CARD_TITLE = 'product-card__title',
  PRODUCT_CARD_ADD_TO_CART = 'product-card__add-to-cart-icon-button',
  PRODUCT_DETAIL_ADD_TO_CART = 'product-detail__add-to-cart-button',
}

export enum AuthTestIds {
  LOGIN_BUTTON = 'auth__login-button',
}

export enum LocalePickerTestIds {
  MODAL = 'locale-picker__modal',
  OPTION = 'locale-picker__option-[code]',
}

export enum MyCartTestIds {
  CTA_BUTTON = 'my-cart__cta-button',
  STEP_CONTAINER = 'my-cart__step-container',
  ADD_ADDRESS_BUTTON = 'my-cart__add-address-button',
  ADDRESS_SAVE_BUTTON = 'my-cart__address-save-button',
}

export enum OrderStatusTestIds {
  THANK_YOU = 'order-status__thank-you',
  MY_ORDERS_BUTTON = 'order-status__my-orders-button',
}

export enum OrdersTestIds {
  TABLE = 'orders__table',
  VIEW_DETAILS_BUTTON = 'orders__view-details-button',
}

export enum OrderDetailTestIds {
  HEADING = 'order-detail__heading',
}

export type TestIds =
  | ProductTestIds
  | AuthTestIds
  | LocalePickerTestIds
  | MyCartTestIds
  | OrderStatusTestIds
  | OrdersTestIds
  | OrderDetailTestIds;
